import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
import moment from "moment";

import alertService from "../../../api/alertConfiguration.service";
export default {
  name: "alert-configuration-list",
  components: { pageheader },
  props: [],
  data() {
    return {
      alertsList: [],
      alertsLoading: false,
      delDialog: false,
      selectedRow: {},
      isDeleting: false,
      statusList: [
        { title: "Enabled", value: "enabled" },
        { title: "Disabled", value: "disabled" },
        { title: "All", value: "all" },
      ],
      selectedStatus: "all",
      headers: [
        { text: "Actions", value: "action", sortable: false, width: "100px" },
        { text: "Alert Name", value: "alertName" },
        { text: "Events", value: "eventName" },
        { text: "Criticality", value: "criticality" },
        { text: "Disabled/Enabled", value: "enabled" },
        { text: "Start Date", value: "startDate" },
        { text: "Last Triggered On", value: "lastTriggeredDate" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "createdBy" },
      ],
      page: 1,
      resetdialog: false,
      dialog: false,
      alerts: [],
      options: {},
      loading: false,
      input: {},
      deleteId: null,
      delName: "",
      isdelete: false,
    };
  },
  watch: {
    "$route.query.type": {
      handler: function (type) {
        this.formType = type;
      },
    },
  },
  created() {},
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("alertconfiguration", this.roles);
    this.getAlerts();
  },

  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  methods: {
    async getAlerts() {
      try {
        this.alertsLoading = true;
        const response = await alertService.fetchAlerts(this.selectedStatus);
        if (response && response.data) {
          this.alertsList = response.data;
          this.alertsLoading = false;
        } else {
          this.alertsList = [];
          this.alertsLoading = false;
        }
      } catch (error) {
        this.alertsList = [];
        this.alertsLoading = false;
        this.$toast.error("Unable to get Alerts");
      }
    },
    confirmDelete(item) {
      this.delDialog = true;
      this.selectedRow = item;
    },
    async updateAlert(item) {
      try {
        const response = await alertService.updateAlert(item.alertConfigId, {
          enabled: item.enabled,
        });
        if (response && response.data) {
          this.$toast.success("Alert updated successfully");
          this.getAlerts();
        } else {
          this.$toast.error("Unable to updated Alert");
        }
      } catch (error) {
        this.$toast.error(error);
      }
    },

    async deleteAlertConfig() {
      try {
        this.isDeleting = true;
        const response = await alertService.deleteAlert(
          this.selectedRow.alertConfigId
        );
        if (response && response.data) {
          this.$toast.success("Alert deleted successfully");
          this.getAlerts();
          this.isDeleting = false;
          this.delDialog = false;
        } else {
          this.isDeleting = false;
          this.$toast.error("Unable to delete Alert");
        }
      } catch (error) {
        this.isDeleting = false;
        this.$toast.error(error);
      }
    },

    onAddNewAlert() {
      this.$router.push("/alert-configuration/add");
    },
  },
};
